import React, { useEffect, useState } from 'react'
import { Breadcrumb } from 'react-bootstrap'
import Card from '../../../UI/Card/Card'
import Graybg from '../../../UI/Graybg'
import SearchInput from '../../../UI/SearchInput/SearchInput'
import SecBTN from '../../../UI/SecBTN'
import Select from '../../../UI/Select/Select'
import classes from './SearchQuestion.module.css'
import userService from '../../../app/services/user.service'
import Loader from '../../../UI/loader/loader'
import { isEmpty, linkReplaceFn } from '../../../utils/custom_funtions'
import Toast from '../../../UI/Toast/Toast'
import { toast } from 'react-toastify'

const SearchQuestion = () => {
  // const [selectedSubject,setSelectedSubject] = useState('');
  // const [searchText,setSearchText] = useState('');
  // const [subjectList,setSubjectList] = useState([]);
  // const [pageNo,setPageNo] = useState(1);
  const [state,setState] = useState({
    selectedSubject:'',
    searchText:'',
    subjectList:[],
    pageNo:1,
    searchedQuestionList:[],
    isLoading:false,
    isError:false,
    errMsg:'',
  });

  useEffect(() => {
    userService.getSubjectList()
    .then(res => {
      console.log(res.data.data)
      setState(prev => {
        return {...prev,subjectList:res.data.data}
      })
    })
    .catch(err => {
      console.log(err)
    })
  }, [])
  const searchHandler = (pageNo) => {
    setState(prev => {return {...prev,isLoading:true}})
    const body = {
      search:state.searchText,
      subid:state.selectedSubject,
      page:pageNo
    }
    userService.getSearchedQuestions(body)
    .then(res => {
      console.log(Object.entries(res.data.data[0]).map(e => e[1]))
      const questionData = Object.entries(res.data.data[0]).map(e => e[1])
      if( state.pageNo > 1 && isEmpty(res.data.data[0])){
        toast.error("No more questions found !!");
        setState(prev => {return {...prev,isLoading:false}})
        return;
      }
      setState((prev) => {
        return {
          ...prev,
          isLoading: false,
          isError: isEmpty(res.data.data[0]) ? true : false,
          errMsg: isEmpty(res.data.data[0]) ? "No Question found !!" : "",
          searchedQuestionList: questionData.map(data => {
            return {
              ...data,
              eqoption:linkReplaceFn(data.eqoption),
              q_text:linkReplaceFn(data.q_text),
              q_text_hindi:linkReplaceFn(data.q_text_hindi),
              qhoption:linkReplaceFn(data.qhoption),
            }
          }),
        };
      });
    })
    .catch(err => {
      setState(prev => {return {...prev,isError:true,errMsg:"Something went Wrong !!",isLoading:false}})
      console.log(err)
    });
  }
  useEffect(() => {
    console.log("page no.", state.pageNo)
    
  }, [state.pageNo])
  
  return (
    <>
    <Toast/>
      {state.isLoading && <Loader />}
      <div className="section">
        <h4>Search Question</h4>
        <Breadcrumb>
          <Breadcrumb.Item>Question</Breadcrumb.Item>
          <Breadcrumb.Item active>Search Question</Breadcrumb.Item>
        </Breadcrumb>
        <Graybg>
          <Card>
            <p>Subject:</p>
            <Select
              className="my-2"
              value={state.selectedSubject}
              onChange={(e) => {
                setState((prev) => {
                  return { ...prev,pageNo:1, selectedSubject: e.target.value };
                });
              }}
            >
              <option value="" disabled>
                Select Subject
              </option>
              {state.subjectList.map((subject) => {
                return (
                  <option key={subject.sub_id} value={subject.sub_id}>
                    {subject.sub_name}
                  </option>
                );
              })}
              {/* <option value=''>Physics</option>
                <option value=''>Chemistry</option>
                <option value=''>Maths</option> */}
            </Select>
            <SearchInput
              placeholder="Permutations and combinations"
              value={state.searchText}
              onChange={(e) => {
                setState((prev) => {
                  return { ...prev,pageNo:1, searchText: e.target.value };
                });
              }}
            />
            <div className="text-center mt-4">
              <SecBTN
                className="sec-btn1"
                disabled={
                  isEmpty(state.searchText) || isEmpty(state.selectedSubject)
                }
                onClick={() => searchHandler(state.pageNo)}
              >
                Search
              </SecBTN>
            </div>
          </Card>
          {/* <DataTable /> */}
          {!isEmpty(state.searchedQuestionList) ? (
            <>
            <div className="table-responsive mb-3">
              <table className="table table-bordered mt-2 mb-0">
                <thead className={classes.tblheader}>
                  <tr>
                    <th>No.</th>
                    <th>QID</th>
                    <th>Question</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(state.searchedQuestionList) &&
                    state.searchedQuestionList.map((questions, index) => {
                      return (
                        <tr key={questions.qid}>
                          <th scope="row">{index + 1}</th>
                          <td>{questions.qid}</td>
                          <td>
                            <p
                              className="mb-2"
                              dangerouslySetInnerHTML={{
                                __html: questions.q_text,
                              }}
                            />
                            <ol
                              style={{
                                listStyleType: "upper-alpha",
                                marginLeft: "30px",
                              }}
                            >
                              {!isEmpty(questions.eqoption) &&
                                [
                                  ...new Set(questions.eqoption.split("@@@")),
                                ].map((data, i) => {
                                  return (
                                    <li key={i}>
                                      {" "}
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: data,
                                        }}
                                      />
                                    </li>
                                  );
                                })}
                            </ol>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className='d-flex justify-content-between'>
            <SecBTN className="sec-btn1" disabled={state.pageNo === 1} onClick={() => {
              setState(prev => {
                return {...prev, pageNo:prev.pageNo - 1 }
              })
              searchHandler(state.pageNo -1)
            }}>Prev</SecBTN>
            <SecBTN className="sec-btn1" onClick={() => {
              setState(prev => {
                return {...prev, pageNo:prev.pageNo + 1 }
              })
              searchHandler(state.pageNo + 1)
            }}>Next</SecBTN>
            </div>
            </>
          ) : state.isError ? (
            <p className="text-center text-danger">{state.errMsg}</p>
          ) : (
           ""
          )}
        </Graybg>
      </div>
    </>
  );
}

export default SearchQuestion
